<!-- Page Header -->
<div class="mb-4">
  <h1 class="h2 mb-1 fw-bold">Safety Tests</h1>
  <p class="text-muted mb-0">Complete required annual knowledge assessments for agricultural drone operations</p>
</div>

<!-- Progress Summary -->
<div class="card mb-4">
  <div class="card-body">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-3">
        <div class="progress-circle">
          <span class="progress-value">{{ completedTests() }}/{{ totalTests() }}</span>
        </div>
        <div>
          <h5 class="mb-1">Annual Certification Progress</h5>
          <p class="text-muted mb-0 small">Complete all required tests to maintain operational compliance</p>
        </div>
      </div>
      <div class="d-none d-md-block">
        <div class="progress w-200px h-8px">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width.%]="totalTests() > 0 ? (completedTests() / totalTests()) * 100 : 0">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Test Cards -->
<div class="row g-4 mb-4">
  <div *ngFor="let test of safetyTests()" class="col-12">
    <div class="card test-card" [class.test-expired]="test.status === 'expired'" [class.test-passed]="test.status === 'passed'">
      <div class="card-body p-4">
        <div class="row align-items-start">
          <!-- Test Icon & Info -->
          <div class="col-lg-7">
            <div class="d-flex align-items-start gap-3">
              <div class="test-icon">
                <i [class]="'bi ' + test.icon"></i>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                  <h4 class="mb-0">{{ test.title }}</h4>
                  <span class="badge" [ngClass]="test.status | statusBadge:'test'">
                    {{ getStatusText(test.status) }}
                  </span>
                  <span *ngIf="isExpiringSoon(test)" class="badge badge-expiring-soon">
                    <i class="bi bi-exclamation-triangle me-1"></i>
                    Expires in {{ getDaysUntilExpiration(test) }} days
                  </span>
                </div>
                <p class="text-muted mb-3">{{ test.description }}</p>

                <!-- Test Stats -->
                <div class="d-flex flex-wrap gap-4 small">
                  <div *ngIf="test.lastScore !== undefined">
                    <span class="text-muted">Last Score:</span>
                    <span class="fw-medium ms-1" [class.text-success]="test.lastScore >= test.passingScore" [class.text-danger]="test.lastScore < test.passingScore">
                      {{ test.lastScore }}%
                    </span>
                  </div>
                  <div>
                    <span class="text-muted">Passing Score:</span>
                    <span class="fw-medium ms-1">{{ test.passingScore }}%</span>
                  </div>
                  <div *ngIf="test.lastAttemptDate">
                    <span class="text-muted">Last Attempt:</span>
                    <span class="fw-medium ms-1">{{ test.lastAttemptDate | adnDate }}</span>
                  </div>
                  <div *ngIf="test.expirationDate">
                    <span class="text-muted">Expires:</span>
                    <span class="fw-medium ms-1" [class.text-danger]="test.status === 'expired'">
                      {{ test.expirationDate | adnDate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="col-lg-5 mt-3 mt-lg-0">
            <div class="d-flex flex-wrap gap-2 justify-content-lg-end">
              <button
                class="btn btn-primary"
                (click)="takeTest(test)"
                [class.btn-warning]="test.status === 'expired'"
              >
                <i class="bi bi-play-fill me-2"></i>
                {{ test.status === 'not_started' ? 'Start Test' : (test.status === 'expired' ? 'Retake Test' : 'Retake Test') }}
              </button>
              <!-- <button class="btn btn-outline-secondary" (click)="viewStudyGuide(test)">
                <i class="bi bi-book me-2"></i>Study Guide
              </button> -->
              <button
                class="btn btn-outline-secondary"
                (click)="viewReport(test)"
                [disabled]="test.status === 'not_started'"
              >
                <i class="bi bi-file-earmark-text me-2"></i>View Report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Info Section -->
<div class="card mt-4">
  <div class="card-header p-3">
    <h6 class="mb-0"><i class="bi bi-info-circle me-2"></i>About Safety Testing</h6>
  </div>
  <div class="card-body">
    <div class="row g-4">
      <div class="col-md-4">
        <h6 class="small fw-bold text-muted mb-2">Annual Requirements</h6>
        <p class="small mb-0">All pilots must complete required safety tests annually to maintain operational certification. Tests expire one year from the completion date.</p>
      </div>
      <div class="col-md-4">
        <h6 class="small fw-bold text-muted mb-2">Study Materials</h6>
        <p class="small mb-0">Each test includes a comprehensive study guide covering all exam topics. Review materials before attempting the test for best results.</p>
      </div>
      <div class="col-md-4">
        <h6 class="small fw-bold text-muted mb-2">Retake Policy</h6>
        <p class="small mb-0">Failed tests may be retaken after a 24-hour waiting period. Passed tests can be retaken at any time to improve scores or renew certification.</p>
      </div>
    </div>
  </div>
</div>
